import React, { createContext, useState, useContext, useEffect } from 'react';
import pb, { getSalonInfos, getOpeningHours, getBlockedDates } from '../services/pocketbase';

const SalonContext = createContext();

export const useSalon = () => useContext(SalonContext);

export const SalonProvider = ({ children }) => {
    const [salonInfos, setSalonInfos] = useState(null);
    const [openingHours, setOpeningHours] = useState([]);
    const [blockedDates, setBlockedDates] = useState([]);
    const [loading, setLoading] = useState(true);

    const refreshData = async () => {
        // setLoading(true); // Eviter le flash de chargement lors d'un refresh manuel
        try {
            const [infos, hours, blocked] = await Promise.all([
                getSalonInfos(),
                getOpeningHours(),
                getBlockedDates()
            ]);

            setSalonInfos(infos || {});

            if (hours) {
                setOpeningHours(hours.sort((a, b) => a.day - b.day));
            }

            if (blocked) {
                setBlockedDates(blocked);
            }

        } catch (error) {
            console.error("Erreur chargement SalonContext:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshData();

        // Abonnement Temps Réel pour les infos du salon (ex: booking_enabled)
        pb.collection('salon_infos').subscribe('*', function (e) {
            console.log('Realtime salon_infos update:', e.action, e.record);
            if (e.action === 'update' || e.action === 'create') {
                setSalonInfos(e.record);
            }
        });

        return () => {
            pb.collection('salon_infos').unsubscribe('*');
        };
    }, []);

    const value = {
        salonInfos,
        openingHours,
        blockedDates,
        loading,
        refreshData
    };

    return (
        <SalonContext.Provider value={value}>
            {children}
        </SalonContext.Provider>
    );
};
